const _afterPaint = (fn) => requestAnimationFrame(() => requestAnimationFrame(fn));
const _mountRebuy = () => {
  const drawer = document.querySelector('cart-drawer .drawer__inner');
  const container = document.querySelector('.rebuy-upsells[data-rebuy-id="247582"]');
  if (!window.Rebuy || !drawer || !container) return;
  const cs = getComputedStyle(drawer);
  if (cs.display === 'none' || cs.visibility === 'hidden' || drawer.getClientRects().length === 0) return;
  window.Rebuy.init?.();
  window.Rebuy.reload?.();
};

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
    this.setupRebuyListeners();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  setupRebuyListeners() {
    document.addEventListener('rebuy:cart.change', (event) => {
      this.refreshCart();
    });
    
    document.addEventListener('rebuy:cart-update', (event) => {
      this.refreshCart();
    });
  }

  refreshCart() {
    fetch(`${window.Shopify.routes.root}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const newCartDrawerItems = html.querySelector("cart-drawer-items");
        const newCartFooter = html.querySelector(".cart-drawer__footer");
        const newRebuyWidget = html.querySelector(".rebuy-upsells");
        
        const currentCartDrawerItems = document.querySelector("cart-drawer-items");
        const currentCartFooter = document.querySelector(".cart-drawer__footer");
        const currentRebuyWidget = document.querySelector(".rebuy-upsells");
        
        if (currentCartDrawerItems && newCartDrawerItems) {
          currentCartDrawerItems.replaceWith(newCartDrawerItems);
        }
        
        if (currentCartFooter && newCartFooter) {
          currentCartFooter.replaceWith(newCartFooter);
        }
        
        if (currentRebuyWidget && newRebuyWidget) {
          currentRebuyWidget.replaceWith(newRebuyWidget);
          _afterPaint(_mountRebuy);
        }
        
        fetch(`${window.Shopify.routes.root}?section_id=cart-icon-bubble`)
          .then((response) => response.text())
          .then((text) => {
            const html = new DOMParser().parseFromString(text, "text/html");
            const newCartIcon = html.querySelector("#cart-icon-bubble");
            const currentCartIcon = document.querySelector("#cart-icon-bubble");
            if (currentCartIcon && newCartIcon) {
              currentCartIcon.innerHTML = newCartIcon.innerHTML;
            }
          });
        
        if (window.Rebuy && typeof window.Rebuy.smartCart === 'function') {
          setTimeout(() => {
            window.Rebuy.smartCart();
          }, 100);
        }
        
        const cartItems = document.querySelector('cart-drawer-items');
        if (cartItems && typeof cartItems.updateShippingBar === 'function') {
          cartItems.updateShippingBar();
        }
      })
      .catch((error) => {
        console.error('Error refreshing cart:', error);
      });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add("overflow-hidden");
    _afterPaint(_mountRebuy);
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      );
      this.open();
      _afterPaint(_mountRebuy);
      if (window.Rebuy && typeof window.Rebuy.smartCart === 'function') {
        window.Rebuy.smartCart();
      }
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);
